const map = {
	"./admin-management/transporter/route/index.tsx": 94344,
	"./alerts/route/index.tsx": 60989,
	"./announcement/route/index.tsx": 84994,
	"./approval-request/route/index.tsx": 63625,
	"./billing-audit-report/route/index.tsx": 58767,
	"./dashboard/route/index.tsx": 57748,
	"./employee-management/employee/route/index.tsx": 60839,
	"./event-logs/route/index.tsx": 38772,
	"./events/route/index.tsx": 26606,
	"./grievance-management/route/index.tsx": 94947,
	"./location-management/commonpoint/route/index.tsx": 16912,
	"./location-management/employee-sequencing/route/index.tsx": 13898,
	"./location-management/location/route/index.tsx": 6364,
	"./logs/route/index.tsx": 64065,
	"./organization-management/route/index.tsx": 80127,
	"./profile/route/index.tsx": 44871,
	"./report-scheduler/route/index.tsx": 92495,
	"./reports/route/index.tsx": 38571,
	"./routes/components/route/index.tsx": 48253,
	"./routes/route/index.tsx": 9792,
	"./security/route/index.tsx": 25038,
	"./settings/brand/route/index.tsx": 43958,
	"./settings/city/route/index.tsx": 97859,
	"./settings/config/route/index.tsx": 6112,
	"./settings/pick-drop-config/route/index.tsx": 75076,
	"./settings/role/route/index.tsx": 29686,
	"./soon/route/index.tsx": 25869,
	"./team-management/route/index.tsx": 84967,
	"./trip-management/manualUpload/route/index.tsx": 46810,
	"./trip-management/trip-billing/route/index.tsx": 3217,
	"./trip-management/trip/route/index.tsx": 42147,
	"./trip-management/tripRequest/route/index.tsx": 69550,
	"./trip-search/route/index.tsx": 61870,
	"./user/route/index.tsx": 70741,
	"./vendor-management/billing-configuration/route/index.tsx": 94951,
	"./vendor-management/cabs/route/index.tsx": 9396,
	"./vendor-management/components/role/route/index.tsx": 70972,
	"./vendor-management/drivers/components/route/index.tsx": 14528,
	"./vendor-management/organization-vendors/components/route/index.tsx": 42229,
	"./vendor-management/vendor-request/route/index.tsx": 50979,
	"./vendor-management/vendor/route/index.tsx": 25471
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48126;